import type { ApiResponse } from "@/types";
import {
  type UseQueryResult,
  queryOptions,
  useQuery,
} from "@tanstack/react-query";
import type { AgentTask } from "../../../schemas/codegen";
import { api } from "../api/api";
import { QUERY_KEYS } from "./queryKeys";

export function getTasksQueryOptions(projectId: string) {
  return queryOptions({
    queryKey: [QUERY_KEYS.TASKS, projectId],
    queryFn: () => api.listTasks(projectId),
    select: (
      response: ApiResponse<{
        tasks: AgentTask[];
      }>,
    ) => response.data.tasks,
  });
}

export function useTasks(
  projectId?: string,
): UseQueryResult<AgentTask[], Error> {
  return useQuery<ApiResponse<{ tasks: AgentTask[] }>, Error, AgentTask[]>({
    queryKey: [QUERY_KEYS.TASKS, projectId],
    queryFn: () => {
      if (!projectId) {
        throw new Error("Project ID is required");
      }
      return api.listTasks(projectId);
    },
    enabled: !!projectId,
    select: (response) => response.data.tasks,
  });
}
